import { SITE } from "./site";
import { faqItems } from "@/mocks/faq";

// Rich LocalBusiness schema shared by every page.
export const businessJsonLd = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "@id": `${SITE.url}/#business`,
  name: SITE.legalName,
  alternateName: SITE.name,
  description:
    "Premium private chauffeur, LAX airport transfer, and city tour service in Los Angeles, California. 24/7 door-to-door rides with a licensed professional driver.",
  url: SITE.url,
  telephone: SITE.phone,
  email: SITE.email,
  priceRange: "$$",
  founder: { "@type": "Person", name: SITE.driver },
  address: {
    "@type": "PostalAddress",
    addressLocality: SITE.city,
    addressRegion: SITE.region,
    addressCountry: SITE.country,
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: SITE.geo.lat,
    longitude: SITE.geo.lng,
  },
  areaServed: [
    "Los Angeles",
    "Beverly Hills",
    "Hollywood",
    "Santa Monica",
    "Malibu",
    "Pasadena",
    "Burbank",
    "Orange County",
  ].map((name) => ({ "@type": "City", name })),
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ],
    opens: "00:00",
    closes: "23:59",
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: SITE.rating.value,
    reviewCount: SITE.rating.count,
    bestRating: 5,
  },
  sameAs: [SITE.social.instagram, SITE.social.facebook],
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Chauffeur Services",
    itemListElement: [
      "LAX Airport Transfer",
      "Hotel Transfer",
      "Event Transportation",
      "Nightlife Chauffeur",
      "Private City Tour",
    ].map((name) => ({
      "@type": "Offer",
      itemOffered: { "@type": "Service", name, areaServed: "Los Angeles, CA" },
    })),
  },
};

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqItems.map((item) => ({
    "@type": "Question",
    name: item.question,
    acceptedAnswer: { "@type": "Answer", text: item.answer },
  })),
};

export const breadcrumbJsonLd = (items: { name: string; path: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE.url}${item.path === "/" ? "/" : item.path}`,
  })),
});
